<template>
    <div class="meetSecondPage1">
        <div class="newsbox" v-if="confereeData.length!=0">
            <div class="meetbox">
                <div class="dataInfoItem" v-for="(item,index) in confereeData" :key="index">
                    <div class="meetName overflowone">
                        {{item.confereeName}}
                    </div>
                    <div class="line"></div>
                    <div class="textbox">
                        <div>会议活动编码：{{item.confereeCode}}</div>
                        <div>会议活动起止时间：{{item.confereeStartTime}} 至{{item.confereeEndTime}}</div>
                        <div class="overflowone">会议活动地点：{{item.confereeSite}}</div>
                        <div class="overflowone">发布机构：{{item.publishOrganization}}</div>
                    </div>
                    <div class="meetdetailBtn" @click="goconfereeDetailFn(item)">
                        详情
                    </div>
                </div>
            </div>
            <div class="pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                    :page-sizes="[6,12,15]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <div class="emptyBox" v-else>
            <img src="@/assets/imgs/home/emptyimg.png" />
        </div>
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
    },
    data() {
        return {
            srcUrl: srcUrl,
            currentPage: 1,
            total: 10,
            pageSize: 6,
            confereeData: []
        }
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                let currentNew = JSON.parse(sessionStorage.getItem('currentNew'))
                if (currentNew) {
                    if (currentNew.currentPage) {
                        this.currentPage = currentNew.currentPage * 1;
                        // this.getNews();
                    }
                    if (currentNew.site) {
                        document.body.scrollTop = currentNew.site
                    }
                }
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        this.getNews()
    },
    methods: {
        async getNews() {
            let params = {
                pageSize: this.pageSize,
                pageCurrent: this.currentPage,
                audit: 1,
                status:1,
            };
            let data = await httpService.getconfereeList(params);
            if (data.code == 200) {
                this.confereeData = data.result.list
                this.total = data.result.total;
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getNews();
        },
        handleCurrentChange(val) {
            // this.pageSize = 1;
            this.currentPage = val;
            this.getNews();
        },
        goconfereeDetailFn(val) {
            let currentNew = {
                menuurl: '/meet-secondpage/meetactive',
                currentPage: this.currentPage,
                site: window.scrollY,
                title: '会议活动'
            }
            sessionStorage.setItem('currentNew', JSON.stringify(currentNew))
            this.$router.push({
                path: "/meet-detail",
                query: {
                    id: val.conferenceId,
                },
            });
        },
    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.meetSecondPage1 {
	width: 1200px;
	.newsbox {
		.meetbox {
			width: 100%;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			// max-height: 620px;
			min-height: 620px;
			position: relative;
			.pagination-box {
				position: absolute;
				bottom: -40px;
				left: 50%;
				transform: translateX(-50%);
			}
			.dataInfoItem {
				width: 383px;
				height: 280px;
				box-shadow: 0px 3px 12px rgba(30, 80, 174, 0.14);
				margin: 0 25px 29px 0;
				padding: 24px 34px 70px 29px;
				box-sizing: border-box;
				position: relative;
				&:nth-child(3n) {
					margin-right: 0;
				}
				// background: url("../../../assets/imgs/solution/page1/img6.png") no-repeat
				//         #fff;
				//       background-position: 100% 100%;
				.meetName {
					font-size: 18px;
					font-weight: bold;
					line-height: 35px;
					color: #448df7;
				}
				.line {
					width: 42px;
					height: 2px;
					background: #448df7;
				}
				.textbox {
					margin-top: 10px;
					font-size: 16px;
					line-height: 30px;
					color: #666666;
					div {
						width: 100%;
					}
				}
				.meetdetailBtn {
					position: absolute;
					bottom: 20px;
					left: 50%;
					transform: translateX(-50%);
					text-align: center;
					background: #448df7;
					width: 118px;
					box-sizing: border-box;
					margin: 0 auto;
					margin-top: 16px;
					line-height: 36px;
					color: #ffffff;
					cursor: pointer;
				}
			}
		}
	}
}
</style>


